<template>
  <div class="flex rounded-lg bg-gray-800 p-1 text-sm">
    <router-link to="/matchmaking" class="px-4 py-2 rounded-md font-semibold text-text-secondary hover:text-text-primary">
      {{ $t('play.lan_party.queue_tab') }}
    </router-link>
    <router-link :to="{ name: 'MatchmakingLanPage' }" class="px-4 py-2 rounded-md font-semibold bg-gray-700 text-white">
      {{ $t('play.lan_party.lan_parties_tab') }}
    </router-link>
  </div>
</template>
